/* eslint-disable no-console */
/* eslint-disable no-undef */
import Vue from 'vue';
import jQuery from 'jquery';

export default {
    emptyFunction() { },

    IFM_CONTEXT: IFM_CONTEXT || '',

    componentManager: {},

    component: {},

    components: {},

    createdComponent: {},

    timeoutManager: {},

    //组件配置信息，格式{grid:{'id':{columns:[]}}}
    compConfigManager: {},

    create: function (type, param) {
        return new this.component[this.toInitialUpperCase(type)](param);
    },

    createObject: function (parent, attr) {
        let property = {};
        if (!this.isEmptyObject(attr)) {
            this.each(attr, function (p, v) {
                property[p] = {
                    value: v
                };
            });
        }
        return Object.create(parent, property);
    },

    getComp: function (id) {
        return jQuery('#' + id).data('gikam.comp.data');
    },

    getAsyncComp: function (id) {
        const comp = Gikam.getInstance('#' + id);
        const def = Gikam.jQuery.Deferred();
        if (comp) {
            return def.resolve(comp);
        } else {
            Gikam.createdComponent[id] = def;
        }
        return def;
    },

    setCompUrl: function () {
        let _this = this;
        this.each(arguments[0], function (compId, url) {
            const comp = _this.getComp(compId);
            comp && comp.setOptions({
                url: url
            });
        });
    },

    printf: function (s, o) {
        let _this = this;
        return s.replace(/{[\w]+}/g, function (match) {
            let value = o[match.replace(/[{}]/g, '')];
            return _this.isEmpty(value) ? '' : value;
        });
    },

    validateRenderToContainer: function (renderTo) {
        let $renderToContainer = renderTo instanceof jQuery ? renderTo : jQuery(renderTo);
        if ($renderToContainer.length === 0) throw new Error('not exists renderTo container');
        return $renderToContainer;
    },

    getText: function (url) {
        return jQuery.ajax({
            url: url,
            dataType: 'text',
            type: 'get'
        });
    },

    getTextSync: function (url) {
        return jQuery.ajax({
            url: url,
            dataType: 'text',
            type: 'get',
            async: false
        });
    },

    getJson: function (url) {
        return jQuery.ajax({
            url: url,
            dataType: 'json',
            type: 'get'
        });
    },

    getJsonSync: function (url) {
        return jQuery.ajax({
            url: url,
            dataType: 'json',
            type: 'get',
            async: false
        });
    },

    post: function (url, jsonData) {
        return jQuery.ajax({
            url: url,
            data: jsonData,
            dataType: 'json',
            type: 'post',
            contentType: 'application/json'
        });
    },

    postSync: function (url, jsonData) {
        return jQuery.ajax({
            url: url,
            data: jsonData,
            dataType: 'json',
            type: 'post',
            async: false,
            contentType: 'application/json'
        });
    },

    postText: function (url, jsonData, header) {
        return jQuery.ajax({
            url: url,
            data: jsonData,
            dataType: 'text',
            type: 'post',
            contentType: 'application/json',
            beforeSend: (xhr) => {
                this.each(header, function (key) {
                    xhr.setRequestHeader(key, encodeURI(this));
                });
            }
        });
    },

    del: function (url, data) {
        return jQuery.ajax({
            url: url,
            data: data,
            dataType: 'text',
            type: 'delete',
            contentType: 'application/json'
        });
    },

    put: function (url, data, header) {
        let param = {
            url: url,
            data: data,
            dataType: 'text',
            type: 'put',
            contentType: 'application/json'
        };

        header && (param.beforeSend = function (xhr) {
            this.each(header, function (key) {
                xhr.setRequestHeader(key, encodeURI(this));
            });
        });

        return jQuery.ajax(param);
    },

    ajax(param) {
        return jQuery.ajax(param);
    },

    toInitialUpperCase: function (s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    },

    toInitialLowerCase: function (s) {
        return s.charAt(0).toLowerCase() + s.slice(1);
    },

    getPageObject: function () {
        return Object.create(arguments[0]);
    },

    requirejs: function (a) {
        let scripts = '';
        let _this = this;
        this.urlManager = this.urlManager || {};
        this.$container = this.$container || jQuery('<div>').appendTo('body');
        a.forEach(function (item) {
            let src = IFM_CONTEXT + item;
            if (!_this.urlManager[src]) {
                scripts += _this.printf(`<script src="${src}"></script>`, { src: src });
                _this.urlManager[src] = true;
            }
        });
        this.$container.html(scripts);
    },

    isEmpty: function (value, allowEmptyString) {
        if (typeof value === 'string') {
            value = value.trim();
        }
        return (value == null) || (!allowEmptyString ? value === '' : false) || (Array.isArray(value) && value.length === 0);
    },

    isNotEmpty: function (value, allowEmptyString) {
        return !this.isEmpty(value, allowEmptyString);
    },

    isTrue: function (value) {
        return value === true || (typeof value === 'string' && value.toLowerCase() === 'true');
    },

    isFalse: function (value) {
        return value === false || (typeof value === 'string' && value.toLowerCase() === 'false');
    },

    confirm: function (title, message, yes, no, yesText, noText) {
        this.create('confirm', {
            title: this.propI18N(title),
            message: this.propI18N(message),
            onYesClick: yes,
            onNoClick: no,
            yesText: yesText,
            noText: noText
        });
    },

    alert: function (message, height) {
        this.create('Alert', {
            message: this.propI18N(message),
            height: height
        });
    },

    override: function (comp, options) {
        if (comp && comp.prototype.setDefaultOptions) {
            comp.prototype.setDefaultOptions(options);
        } else {
            Object.assign(comp.prototype, options);
        }
    },

    getLastModal: function () {
        return this.getInstance(jQuery('body').children('.modal:last'));
    },

    refreshGrids: function (mapper, data) {
        let _this = this;
        for (let gridId in mapper) {
            if (mapper.hasOwnProperty(gridId)) {
                _this.getAsyncComp(gridId).done(grid => {
                    grid.refresh({
                        url: _this.printf(mapper[gridId], data)
                    })
                });
            }
        }
    },

    refreshForms: function (mapper, data) {
        for (let formId in mapper) {
            if (mapper.hasOwnProperty(formId)) {
                this.getComp(formId).refresh({
                    url: this.printf(mapper[formId], data)
                });
            }
        }
    },

    param: function (o, questionMark) {
        let prev = questionMark === false ? '' : '?';
        let serialize = '';
        let _this = this;
        this.each(o, function (p, v) {
            if (_this.isNotEmpty(v)) {
                serialize += '&' + (p + '=' + v);
            }
        });
        return prev + serialize.replace('&', '');
    },

    extend: function () {
        return jQuery.extend.apply(jQuery, arguments);
    },

    isPlainObject: function () {
        return jQuery.isPlainObject(arguments[0]);
    },

    isEmptyObject: function () {
        return jQuery.isEmptyObject(arguments[0]);
    },

    each: function () {
        jQuery.each.apply(jQuery, arguments);
    },

    isNumber: function (value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    },

    openFile: function (fileId, readonly) {
        const pre = 'weboffice://|Officectrl.com|';
        const pageUrl = IFM_CONTEXT + '/core/component/item/files/page/web-office';
        const url = pre + pageUrl + this.param({
            fileId: fileId,
            readonly: readonly
        });
        window.open(url, '_self');
    },

    propI18N: function (key) {
        return this.component.I18N.prop(key) || key;
    },

    openGantt: function (ganttJsUrl, ganttDataUrl, title) {
        let src = IFM_CONTEXT + '/core/component/item/files/page/dhtmlx-gantt?ganttjsurl='
            + encodeURI(ganttJsUrl) + '&ganttDataUrl=' + encodeURI(ganttDataUrl);
        this.create('modal', {
            title: title || 'this.MODAL.CHECK_GANTT',
            iframe: true,
            isFullScreen: true,
            src: src
        });
    },

    openChem: function (targetId, readonly, title) {
        let src = IFM_CONTEXT + '/core/component/item/files/page/chem-draw?targetId=' + targetId + '&readonly=' + readonly;

        this.create('modal', {
            title: title || 'this.MODAL.CHEM',
            iframe: true,
            isFullScreen: true,
            src: src
        });
    },

    print: function ($dom, css) {
        let $iframe = jQuery('<iframe src=""></iframe>').appendTo('body'), w = $iframe[0].contentWindow;
        (css || []).unshift(IFM_CONTEXT + '/static/this/framework/css/this.css');

        jQuery(w.document.body).append(css.reduce(function (total, item) {
            return total + '<link rel="stylesheet" href="' + item + '"/>';
        }, '')).append($dom.clone());

        let $css = jQuery(w.document.body).children('link');

        let interval = setInterval(function () {
            let result = true;
            this.each($css, function () {
                if (this && this.sheet && this.sheet.cssRules) {
                    return true;
                } else {
                    return result = false;
                }
            });
            if (result === true) {
                clearInterval(interval);
                w.print();
            }
        }, 100);
    },

    getInstance: function (dom) {
        return jQuery(dom).data('gikam.comp.data');
    },

    setInstance(dom, object) {
        jQuery(dom).data('gikam.comp.data', object);
    },

    removeDomStyle: function ($dom, array) {
        array.forEach(function (item) {
            $dom.css(item, '');
        });
    },

    ignoreErrorUrl: [],

    setPrototype: function (func, proto) {
        func.prototype = proto;
        return func;
    },

    extendClass: function (child, parent) {
        child.prototype = parent.prototype;
        return child;
    },

    deepExtend: function (...args) {
        if (args.length === 1 && Array.isArray(args[0])) {
            return this.extend(true, [], args[0]);
        }
        return jQuery.extend.apply(jQuery, [true, {}].concat(Array.prototype.slice.apply(arguments, [0])));
    },

    /* 
    *  将form对象的属性值拷贝覆盖到target对象,深度拷贝
    */
    deepAssign: function (target, from) {
        jQuery.extend(true, target, from);
    },

    download: function (url) {
        const a = this.createDom('a', document.body);
        this.setDomAttribute(a, { href: url, download: url.substr(url.lastIndexOf('/') + 1) });
        a.click();
    },

    getJsonWrapper() {
        let args = Array.prototype.slice.apply(arguments);
        let JsonWrapper = function () {
            let _this = this;
            args.forEach(function (item, i) {
                if (i === 0) {
                    item ? _this.p = item : null;
                } else {
                    _this['b' + (i === 1 ? '' : (i - 1))] = item;
                }
            });
        };
        return JSON.stringify(new JsonWrapper());
    },

    getFieldValue: function (item, field) {
        let value;
        if (field) {
            if (field.indexOf('ext$') === 0) {
                if (item.ext$) {
                    let v = item.ext$[field.split('.')[1]];
                    v === void 0 ? value = void 0 : value = v;
                } else {
                    value = void 0;
                }
            } else {
                value = item[field];
            }
        }
        return value;
    },

    setFieldValue(data, field, value) {
        if (field.indexOf('ext$') > -1) {
            Vue.set(data.ext$, field.replace('ext$.', ''), value);
        } else {
            Vue.set(data, field, value);
        }
    },

    printFile() {

    },

    /**
     * @description 打开office编辑页面
     * @public
     * @param {Object} 编辑器参数
     * @memberof Gikam
     */
    editOfficeFile(options) {
        new this.EditorOffice(options);
    },

    getRequestParam: function (urlStr) {
        let url = urlStr ? urlStr.substr(urlStr.indexOf('?')) : location.search;
        let param = {};
        if (url.indexOf("?") !== -1) {
            url.substr(1).split("&").forEach(function (item) {
                let array = item.split('=');
                param[array[0]] = unescape(array[1]);
            });
        }
        return param;
    },

    argsToArray: function (args) {
        let argsArray = [];
        for (let i = 0; i < args.length; i++) {
            argsArray.push(args[i]);
        }
        return argsArray;
    },

    preInsert(options) {
        const def = jQuery.Deferred();

        //分区域展示的字段
        if (options.fields && Gikam.isNotEmpty(options.fields) && Gikam.isNotEmpty(options.fields[0].fields)) {
            options.fields = options.fields.reduce((total, item) => {
                return total.concat(item.fields);
            }, []);
        }

        const fields = options.fields ? options.fields.filter(item => item.preInsert).map(item => {
            let copyItem = jQuery.extend(true, [], item);
            if (options.disableNotEmptyValidate !== true) {
                if (!copyItem.validators) {
                    copyItem.validators = [];
                }
                if (copyItem.validators.indexOf('notEmpty') === -1) {
                    copyItem.validators.push('notEmpty');
                }
            }
            copyItem.colspan = 1;
            return copyItem;
        }) : null;

        const insert = () => {
            modal && modal.window.showMask();
            const data = ['', [Gikam.extend(form ? form.getData() : null, options.param)]];
            //没有预新增字段直接新增
            Gikam.postText(options.url, Gikam.getJsonWrapper(form ? { t: getFieldInfoByData(form.getData()) } : null, data)).done((id) => {
                modal && modal.close();
                modal && modal.window.closeMask();
                def.resolve(id);
            }).fail(() => {
                modal && modal.window.closeMask();
            });
        };

        //没有预新增字段，直接插入数据
        if (Gikam.isEmpty(fields)) {
            insert();
            return def;
        }

        const highHeightTypes = ['textarea', 'image', 'checkbox'];
        const highTypeFields = fields.filter((item) => {
            return highHeightTypes.indexOf(item.type) > -1;
        })

        /**
         * 118 = 108 + 10   
         * 108:modal 头部和底部
         * 10 ：form  padding-top
         * 42: input 高30  + margin-bottom 12
         * 8: 多文本比单文本多出的高度
         */
        const modalHeight = fields.length * 42 + highTypeFields.length * 8 + 118;

        const modal = Gikam.create('modal', {
            title: options.modalTitle,
            width: options.width || 400,
            height: options.height || modalHeight
        });

        const layout = Gikam.create('layout', {
            renderTo: modal.window.$dom,
            center: {
                items: [{
                    type: 'btnToolbar',
                    items: [{
                        type: 'button',
                        text: '确认',
                        class: 'blue',
                        onClick() {
                            if (form.validate()) {
                                insert();
                            }
                        }
                    }, {
                        type: 'button',
                        text: '取消',
                        onClick() {
                            modal.close();
                        }
                    }
                    ]
                }]
            }
        });

        const form = Gikam.create('form', {
            renderTo: layout.options.center.$dom,
            columns: options.columns || 1,
            titleWidth: options.titleWidth || 80,
            fields: fields,
            autoSave: false
        });

        if (options.onFormRendered) {
            options.onFormRendered.apply(form);
        }

        const getFieldInfoByData = (data) => {
            const fieldInfo = {};
            form.options.fields.forEach(fieldOptions => {
                if (Gikam.isNotEmpty(data[fieldOptions.field], true) && ['select', 'simpleCheckbox'].indexOf(fieldOptions.type) > -1) {
                    const options = {
                        type: fieldOptions.type === 'simpleCheckbox' ? 'checkbox' : (fieldOptions.type || 'text'),
                    };
                    if (fieldOptions.type === 'select') {
                        options.items = fieldOptions.items;
                    }
                    fieldInfo[fieldOptions.field] = options;
                }
            });
            return fieldInfo;
        };

        return def;
    },

    /**
     * @description 控制台输出错误信息
     * @public
     * @param {String} message 错误信息
     */
    error(message) {
        console.error('[Gikam error info]:' + message)
    },

    /**
     * @description 控制台输出警告信息
     * @public
     * @param {String} message 警告信息
     */
    warn(message) {
        console.warn('[Gikam warn info]:' + message);
    },

    importExcel(options) {
        options.multiple = false;
        options.onAfterClose = (files) => {
            if (Gikam.isEmpty(files)) {
                return;
            }
            workspace.window.showMask();
            Gikam.post(Gikam.printf(options.url, {
                id: files[0].id
            })).done(function (result) {
                if (result.url) {
                    Gikam.download(result.url);
                } else if (result.message) {
                    Gikam.alert(result.message);
                }
                if (options.onImportSuccess) {
                    options.onImportSuccess.call(null, files);
                }
            }).always(function () {
                workspace.window.closeMask();
            });
        }
        Gikam.create('simpleUploader', options);
    },

    import(options) {
        this.importExcel(options);
    },

    /** 
     * @description 设置所有组件默认参数,配置示例如下{ Grid:{page : false}}
     * @public
     */
    setCompConfig(config) {
        for (let key in config) {
            Gikam.override(Gikam.component[Gikam.toInitialUpperCase(key)], { defaultOptions: config[key] });
        }
    },

    /**
     * @description 设置组件对象配置信息
     * @param {Object} 配置信息,例如{grid:{gridId1:{columns:[]}},form:{formId1:{fields:[]}}}
     */
    setCompParam(param) {
        this.deepAssign(this.compConfigManager, Gikam.isString(param) ? JSON.parse(param) : param);
    },

    setDomAttribute(dom, attribute) {
        for (let key in attribute) {
            dom.setAttribute(key, attribute[key]);
        }
    },

    createDom(domTag, renderToDom) {
        const dom = document.createElement(domTag);
        renderToDom.appendChild(dom);
        return dom;
    },

    removeDom(dom) {
        dom.parentNode.removeChild(dom);
    },

    isString(str) {
        return typeof str === 'string';
    },

    /**
     * @description 清空组件数据方法，主要针对Form和Grid
     * @param {String} compIdArray 组件id集合
     * @returns
     */
    cleanCompData(compIdArray) {
        if (Gikam.isEmpty(compIdArray)) {
            return;
        }
        compIdArray.forEach((compId) => {
            const comp = Gikam.getComp(compId);
            if (comp) {
                comp.cleanData();
            }
        });
    },

    /**
     * @description 触发对象中的方法，并指定方法的上下文和参数
     * @private 
     * @param {Object} object 调用方法坐在的对象
     * @param {String} eventName 事件名称
     * @param {Object} scope 回调方法中的上下文
     * @param {*} args 回调方法中的参数
     */
    trigger(object, eventName, scope, ...args) {
        if (!object[eventName]) {
            return;
        }
        object[eventName].apply(scope, args);
    },

    getElParam(p) {
        var param = {};
        for (var key in p) {
            if (key === '_') {
                continue;
            }
            param[key] = p[key][0];
        }
        return param;
    },

    /**
     * @description 过滤Tree类型数组
     * @public
     * @param {Array} treeList 存在children子节点类型的数组
     * @param {Function} callback 过滤回调函数
     * @returns Tree类型数组
     */
    filterTree(treeList, callback) {
        if (!Array.isArray(treeList)) {
            Gikam.error('treeList expected array type');
            return;
        }

        const filterNode = (nodeList) => {
            return nodeList.filter(item => {
                if (Gikam.isNotEmpty(item.children)) {
                    item.children = filterNode(item.children);
                }
                if (Gikam.isNotEmpty(item.children)) {
                    return true;
                } else {
                    return callback(item);
                }
            });
        };

        return filterNode(Gikam.deepExtend(treeList));
    },

    /**
     * @description 对树类型数组进行遍历
     * @param {Array} treeList
     * @param {Function} callback
     */
    eachTree(treeList, callback) {
        if (!Array.isArray(treeList)) {
            Gikam.error('treeList expected array type');
            return;
        }

        const eachNode = (nodeList) => {
            return nodeList.forEach(item => {
                if (Gikam.isNotEmpty(item.children)) {
                    eachNode(item.children);
                }
                callback(item);
            });
        };

        return eachNode(treeList);
    },

    /**
     * @description 高频率执行延时操作时，只执行最后一次动作
     * @public
     * @param {String} flag 唯一标识一次延时，例如：searchInputTimeout
     * @param {Function} callback 执行方法
     * @param {Number} timeout
     */
    finalDelay(flag, callback, timeout) {
        if (this.timeoutManager[flag]) {
            clearTimeout(this.timeoutManager[flag]);
        }
        this.timeoutManager[flag] = setTimeout(() => {
            callback();
            delete this.timeoutManager[flag];
        }, timeout);
    },

    /**
     * @description 创建带有确认取消按钮，并且不含url的Modal
     * @param {Object} 
     *        {title:'modal标题',onConfirm:()=>{},onCancel:()=>{},
     *        toolbarFormatter:(toolbar)=>{}}
     * @returns {Modal}
     */
    createSimpleModal(props) {
        const modal = Gikam.create('modal', {
            title: props.title,
            width: props.width,
            height: props.height
        });
        let toolbar = [{
            type: "button",
            text: "取消",
            onClick() {
                props.onCancel();
            }
        }, {
            type: "button",
            text: "确定",
            class: "blue",
            onClick() {
                props.onConfirm();
            }
        }];
        if (props.toolbarFormatter) {
            toolbar = props.toolbarFormatter(toolbar);
        }
        const layout = Gikam.create("layout", {
            renderTo: modal.window.$dom,
            center: {
                items: [
                    {
                        type: "btnToolbar",
                        items: toolbar
                    }
                ]
            }
        });
        return { modal, layout };
    }
};






